
import Header3 from "../Header3"
import PageBanner from "../PageBanner"
import Footer3 from "../Footer3"
import bannerBg from "../../assets/img/page-banner.jpg"
import "./Portal.css"
import { useEffect, useState } from "react"
import { Helmet } from "react-helmet"

import AgentLogin from "./AgentLogin"
import AgentSignup from "./AgentSignup"
import { toast, ToastContainer } from "react-toastify"




const AgentPortal = () => {
    const [page, setPage] = useState("login");

    // agent state object
    const [agent,setAgent] = useState({
        name: "",
        company: "",
        password: "",
        country: "",
        phone:"",
        fax: "",
        email: "",
    })

    // handle login and signup toggle and empty password field
    const handleTogglePage = (type) => {
        setPage(type);

        setAgent(prev => ({
                            ...prev,
                            password: "",
                        }));
    }

    // store input into agent state
    const handleInput = (e) => {
        const {name,value} = e.target;
        setAgent({
            ...agent,
            [name]: value
        });
    }

    let page_title = page === 'login' ? "Agent Login Portal" : "Agent Signup Portal";
    page_title = page_title.slice(0,60).toUpperCase() 
    
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                theme="colored"
            />
            <Helmet>
                <title>{`Testfabrics.com: ${page_title}`}</title>
            </Helmet>
            <Header3/>
            <PageBanner bannerBg={bannerBg} currentPage="Agent Portal"  />
            <section className="portal ">
                {
                    page === "login" ? (
                        <AgentLogin handleInput={handleInput} agent={agent} handleTogglePage={handleTogglePage}/>       
                    ) : (
                        <AgentSignup handleInput={handleInput} agent={agent} handleTogglePage={handleTogglePage}/>
                    )
                }
            </section>

            <Footer3/>
        </>
    );
}


export default AgentPortal